import { createKey } from './createKey';
import { JobClassificationSearchRequest } from '@trukt/tms-api/JobClassificationService';

const keyHandler = createKey('job-classification');

export const JobClassificationServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<JobClassificationSearchRequest>(),
};
